export default __webpack_public_path__ + "static/media/absent.c7cc1696.svg";